import React, { Component } from "react";
import { Card, CardHeader, CardBody, Col } from "reactstrap";
import FlagItem from "./FlagItem";
import { CLOUDINARY_SHARE } from "../../helpers/cloudinaryConstants";

class ShoutItem extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.gnObject.id !== nextProps.gnObject.id;
  }

  render() {
    const { gnObject } = this.props;
    return (
      <Col xs="12" md="6">
        <Card>
          <CardHeader>Shout</CardHeader>
          <CardBody>
            <h5>Business: {gnObject.business.name}</h5>
            <h6>ID: {gnObject.business.id}</h6>
            <hr />
            {!gnObject.image.isDefault && (
              <img
                style={{ width: "50%" }}
                src={`${CLOUDINARY_SHARE}/${gnObject.image.image.cloudinaryId}`}
              />
            )}
            <p>{gnObject.text}</p>
            {gnObject.gnObjectAttached && (
              <FlagItem
                isChild
                type={gnObject.gnObjectAttached.type}
                gnObject={gnObject.gnObjectAttached.gnObject}
              />
            )}
          </CardBody>
          {this.props.children}
        </Card>
      </Col>
    );
  }
}

export default ShoutItem;



// WEBPACK FOOTER //
// ./src/views/Components/ShoutItem.js